import { useNavigate } from 'react-router-dom';
import AppLoader from './components/AppLoader';

function App() {
  const navigate = useNavigate();
  return <AppLoader onAnimationEnd={() => navigate('/my-organizations')} />;
}

export default App;
